module.exports = __webpack_public_path__ + "Server-Healthy-AzureCloudService.cd2c174c2f7de57f1983f67352bd06e9.hashedasset.svg";